import { render } from "./RenderDialog.vue?vue&type=template&id=6746739b&ts=true"
import script from "./RenderDialog.vue?vue&type=script&lang=ts"
export * from "./RenderDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__